'use strict';

import main from './lib/MlbTbdTeamToLeagueMap';

export default main;

